import { privilegedPositions } from "./constants";
import useUserStore from "../stores/userStore";

const USER_PERMISSION_OVERRIDES = {
    104: new Set([
        "approve_deny_events",
        "edit_events_for_others",
        "view_call_center",
    ]),
    105: new Set([
        "approve_deny_events",
        "edit_events_for_others",
        "view_daysmart",
        "view_call_center",
        "view_team_status",
    ]),
    154: new Set([
        "approve_deny_events",
        "edit_events_for_others",
        "view_daysmart",
        "view_call_center",
    ]),
};

/**
 * Check if a user has a specific permission.
 * Reads from the Zustand permissions set loaded from the backend.
 */
export function hasPermission(permission) {
    const { currentUser, permissions } = useUserStore.getState();
    if (permissions.has(permission)) {
        return true;
    }

    const userId = Number(currentUser?.user_id);
    return USER_PERMISSION_OVERRIDES[userId]?.has(permission) === true;
}

/**
 * Backward-compat: returns true if the user has any permissions at all.
 * Falls back to position-based check if permissions haven't loaded yet.
 */
export function isPrivileged(user) {
    const permissions = useUserStore.getState().permissions;
    if (permissions && permissions.size > 0) {
        return true;
    }
    // Fallback to position-based check (before permissions are loaded)
    const position = user?.position?.toLowerCase();
    return privilegedPositions.includes(position);
}
